import { Component } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AtokuAccessCredentials } from '@features/atoku/services/atoku.service';
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {
  AtokuCompanyTypeSelectComponent
} from "../../../../../atoku/common/atoku-company-type-select/atoku-company-type-select.component";

@Component({
  selector: 'app-atoku-approve-dialog',
  templateUrl: './atoku-approve-dialog.component.html',
  imports: [
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    AtokuCompanyTypeSelectComponent
  ],
  standalone: true
})
export class AtokuApproveDialogComponent {
  /**
   * TEMP: the select needs credentials input.
   * Your current getPricingProfileTypes() returns hardcoded data anyway,
   * so this keeps the control happy until credentials wiring is added.
   */
  readonly credentials: AtokuAccessCredentials = { companyId: '', apiKey: '', siteId: '' };

  readonly form = new FormGroup({
    companyTypeCode: new FormControl<string | null>(null, Validators.required),
  });

  constructor(private dialogRef: MatDialogRef<AtokuApproveDialogComponent>) {}

  close(): void {
    this.dialogRef.close(null);
  }

  approve(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(this.form.value.companyTypeCode);
  }
}
